import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getListAvatars = () => http.get('/avatars').then(handleResponse);

export const updateAvatar = (agentId, avatarId) =>
  http.put(`/avatars/agent/${agentId}`, { avatar_id: avatarId });
